import { gql } from '@apollo/client'
import { PHYSICAL_STORE_FRAGMENT } from '../fragments'

export const CREATE_STORE_MAP = gql`
  mutation CreateStoreMap($input: StoreMapInput!) {
    createStoreMap(input: $input) {
      storeMap {
        id
        geoJson
        store {
          ...PhysicalStore
        }
      }
    }
  }
  ${PHYSICAL_STORE_FRAGMENT}
`
